<!--   文档对应的左侧栏颜色，想要和文档一致，改成这个颜色就好 background-color="#545c64"-->
<template>
  <el-menu
    class="el-menu-vertical-demo"
    :default-active="activeMenuPath"
    :collapse="isCollapse"
    :default-openeds="defaultOpeneds"
    background-color="transparent"
    text-color="#284140"
    active-text-color="#ffffff"
    :collapse-transition="false"
  >
    <div class="brand-block">
      <img
        :src="$brand.logoUrl"
        alt=""
        class="brand-logo"
      />
      <div v-if="!isCollapse" class="brand-copy">
        <strong>{{ $brand.sidebarTitle }}</strong>
        <span>Unified HR workspace</span>
      </div>
    </div>
    <el-menu-item
      v-for="item in noChildren"
      :key="item.id"
      :index="getMenuPath(item)"
      @click="clickMenu(item, getMenuPath(item))"
    >
      <i :class="'el-icon-' + item.icon"></i>
      <span slot="title"> {{ item.name }}</span>
    </el-menu-item>
    <el-submenu v-for="item in hasChildren" :key="item.id" :index="getMenuPath(item)">
      <template slot="title">
        <i :class="'el-icon-' + item.icon"></i>
        <span>{{ item.name }}</span>
      </template>
      <el-menu-item
        v-for="subItem in item.children"
        @click="clickMenu(subItem, getMenuPath(subItem, item))"
        :key="subItem.id"
        :index="subItem.name"
      >
        <i :class="'el-icon-' + subItem.icon"></i>
        <span>{{ subItem.name }}</span>
      </el-menu-item>
    </el-submenu>
    <div v-if="!isCollapse" class="menu-footer">
      <span>Workspace</span>
      <strong>Core + Add-ons</strong>
    </div>
  </el-menu>
</template>

<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
}

.el-menu {
  height: 100%;
  border: none;
  padding: 18px 14px;
  background: transparent !important;

  /deep/ .el-menu-item,
  /deep/ .el-submenu__title {
    height: 48px;
    line-height: 48px;
    margin-bottom: 8px;
    border-radius: 16px;
    font-size: 14px;
    color: #284140 !important;
    transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  }

  /deep/ .el-menu-item i,
  /deep/ .el-submenu__title i {
    margin-right: 12px;
    color: rgba(40, 65, 64, 0.62);
  }

  /deep/ .el-menu-item:hover,
  /deep/ .el-submenu__title:hover {
    background: rgba(66, 109, 159, 0.08) !important;
    transform: translateX(2px);
    box-shadow: inset 0 0 0 1px rgba(66, 109, 159, 0.14);
  }

  /deep/ .el-menu-item.is-active {
    background: linear-gradient(135deg, rgba(29, 53, 87, 0.96), rgba(66, 109, 159, 0.9)) !important;
    box-shadow: 0 12px 24px rgba(29, 53, 87, 0.24);
  }

  /deep/ .el-menu-item.is-active i {
    color: #ffffff;
  }

  /deep/ .el-submenu .el-menu {
    padding-top: 6px;
    background: transparent !important;
  }

  /deep/ .el-submenu .el-menu-item {
    padding-left: 52px !important;
    margin-bottom: 6px;
    background: rgba(255, 255, 255, 0.42) !important;
  }
}

.brand-block {
  display: flex;
  align-items: center;
  min-height: 72px;
  padding: 6px 10px 18px;
}

.brand-logo {
  width: 38px;
  height: 38px;
  margin-right: 12px;
  object-fit: contain;
  filter: drop-shadow(0 10px 18px rgba(14, 29, 55, 0.18));
}

.brand-copy {
  min-width: 0;

  strong,
  span {
    display: block;
  }

  strong {
    color: #183534;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.2;
  }

  span {
    margin-top: 4px;
    color: rgba(40, 65, 64, 0.62);
    font-size: 12px;
    letter-spacing: 0.03em;
  }
}

.menu-footer {
  margin-top: 18px;
  padding: 16px 14px;
  border: 1px solid rgba(28, 59, 59, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.52);

  span,
  strong {
    display: block;
  }

  span {
    color: rgba(40, 65, 64, 0.54);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  strong {
    margin-top: 8px;
    color: #183534;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>

<script>
import { mapState } from 'vuex'
import { resolveMenuPath } from '../utils/menu-route'

export default {
  data () {
    return {
      isCollapse: false // 控制侧边栏是否展开
    }
  },
  methods: {
    clickMenu (menu, path) {
      // 使用编程式，路由导航
      this.$router.push({
        path: path // 点击菜单，进行跳转
      })
      this.$store.commit('tag/ADD_TAG', menu)
    },
    getMenuPath (menu, parentMenu) {
      return resolveMenuPath(menu, parentMenu)
    }
  },
  computed: {
    ...mapState('menu', ['menuList']),
    noChildren () {
      return this.menuList.filter(item => item.children.length === 0) // 没有子菜单
    },
    hasChildren () {
      return this.menuList.filter(item => item.children.length > 0) // 有子菜单
    },
    defaultOpeneds () {
      return this.hasChildren.map(item => this.getMenuPath(item))
    },
    activeMenuPath () {
      return this.$route.path
    }
  },
  mounted () {
    this.$bus.$on('collapseMenu', () => {
      this.isCollapse = !this.isCollapse
    })
  },
  beforeDestroy () {
    this.$bus.$off('collapseMenu')
  }
}
</script>
